export default __webpack_public_path__ + "static/media/sandesh.9be6df0c.jpeg";